/*
    [type conventions]:
        p - content is text and should be in <card> component [name of component tbd]
        p-noBorder - content is text and should be in <p>
        video - content is a video and should be in <video>
        img - content is an image and should be in <img>
        list - content has multiple lines of text and should be in <li>

        [...more to be added...maybe]
*/
import { AssetHost } from '../../../config'
import AssignToStudent_1 from '../../../assets/img/dashboard/Homepage/AssignToStudents1.png'
import SeeWhoHasCreatedCharacter from '../../../assets/img/dashboard/Homepage/SeeWhoHasCreatedACharater.png'
import _ from 'lodash'

export const teacher_selfStartPath = {
    hasVisitedStorylines: {
        contextValue: 'exploreContent',
        mainTitle: 'Explore Content',
        mainContent: [
            [
                {
                    title: 'Modules & Alignment with Standards',
                    content: [
                        {
                            type: 'p',
                            text: `Our Content is grouped by Modules (topics). For an overview of how our content aligns with standards (e.g.: NGSS, GA GSE), click on the link below.`
                        },
                        {
                            type: 'link',
                            text: 'View Chart',
                            url: 'https://docs.google.com/spreadsheets/d/1NwwdXa302E73sXcFmbXqG2D9QqldWQk9NMwQ9nxltXI/edit#gid=0'
                        }
                    ]
                },
                {
                    title: 'Storylines',
                    content: [
                        {
                            type: 'p',
                            text: 'For each module, there are pre-designed storylines that lead students through building their knowledge until they have mastered the bundle of standards.'
                        }
                    ]
                },
                {
                    title: 'Sandboxes',
                    content: [
                        {
                            type: 'p',
                            text: 'Some modules also have a sandbox that is designed to be an open-ended experience. It can be used as a capstone after completing the storylines, or as an ongoing project along side of the quests.'
                        }
                    ]
                }
            ]
        ],
        bannerContent:
            'Go to “Explore &amp; Assign” to check out our contents. Take a look at at least one storyline.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Show Me Step by Step',
                url: 'modules?userflow=8f43fc33-bac7-4224-ad58-9addac4ea3e5',
                isExternal: false
            }
        ]
    },
    hasSelfAssigned: {
        contextValue: 'assignYourself',
        mainTitle: 'Assign To Yourself',
        mainContent: [
            [
                {
                    content: [
                        {
                            type: 'video',
                            url: 'https://www.youtube.com/embed/KDdirFJE6OA'
                        }
                    ]
                },
                {
                    title: 'Assigning Yourself',
                    content: [
                        {
                            type: 'p',
                            text: 'Most teachers prefer to play the game themselves before assigning it to students. This allows you to experience what the students will experience and to anticipate places where you can help students if they get stuck, to make connections, and to formulate questions that you can ask students. '
                        },
                        {
                            type: 'p',
                            text: 'Fill out the assignee and date on the assignment popup window to create an assignment. Select “Myself” on the top of the assignee list to have it go to your account.'
                        },
                        {
                            type: 'card',
                            title: 'Did You Know?',
                            text: `You can track and manage all the assigned quests to be completed on the <a href='/calendar'>Calendar</a> page.`,
                            link: 'https://intercom.help/tytoonline/en/articles/5228387-use-the-calendar-to-keep-track-of-to-be-completed-quests'
                        }
                    ]
                }
            ]
        ],
        bannerContent: 'Go to “Explore &amp; Assign” to assign something to yourself.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Show me Step by Step',
                url: 'modules?userflow=5d31d554-7344-4ed4-b503-8e50e31e860c',
                isExternal: false
            },
            {
                actionType: 'button',
                style: 'white',
                text: 'Skip This Step For Now',
                isExternal: false
            }
        ]
    },
    hasCreatedCharacter: {
        contextValue: 'getInGame',
        mainTitle: 'Get into the Game',
        bannerContent:
            'Go to “Play the Game” to open the game. You will be guided to create your character and learn the controls.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Go to the Game',
                url: AssetHost(),
                isExternal: true
            }
        ]
    },
    hasCompletedQuest: {
        contextValue: 'completeQuest',
        mainTitle: 'Complete your first Quest',
        mainText:
            'Complete the quest “Welcome Citizen” that is automatically given first, or another quest you assigned to yourself.',
        bannerContent: 'Go to “Play the Game” to open the game and complete a quest.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Go to the Game',
                url: AssetHost(),
                isExternal: true
            }
        ]
    }
}

export const teacher_studentStartPath = {
    hasCreatedClass: {
        contextValue: 'createClass',
        mainTitle: 'Create A Class',
        mainText:
            'Create a class by clicking on the square with “+” and then enter information in the “Manage Classes” page.',
        bannerContent: 'Go to “Manage Classes” to create a class.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Show Me Step by Step',
                url: 'classes?userflow=7b9cdd8f-a669-438b-9b17-683f2ff39bef',
                isExternal: false
            }
        ]
    },
    hasPopulatedClass: {
        contextValue: 'addStudent',
        mainTitle: 'Add Students To A Class ',
        mainContent: [
            [
                {
                    content: [
                        {
                            type: 'p',
                            text: `Adding students to a class can be done in <strong>either</strong> of the 3 ways.`
                        },
                        {
                            type: 'list-card',
                            content: [
                                {
                                    subTitle: 'Import from Google Classroom',
                                    text: 'You can import your roster using Google Classroom. We will automatically create accounts for your students and they can log in with their email.'
                                },
                                {
                                    subTitle: 'Ask Students to Join by Class Code',
                                    text: `Students can self-register by using a class code.  We have also included <a href='https://docs.google.com/presentation/d/1gXa_e8PQzkLGNypG7fMp8nyQgiT0E4TVV4jtSeemCTc/edit#slide=id.p' target='_blank'>registration directions</a> for students. You can fill in the class code, then distribute it to students. `
                                },
                                {
                                    subTitle: 'Manual',
                                    text: `Manually add students' first and last names. We will automatically generate a username and password for them. `
                                }
                            ]
                        }
                    ]
                }
            ]
        ],
        bannerContent: 'Go to your empty class in “Manage Classes” to add students.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Show Me Step by Step',
                url: 'classes?userflow=1e5832c5-5ec5-4b9b-b7a9-de77a35864ac',
                isExternal: false
            }
        ]
    },
    hasStudentCreatedCharacter: {
        contextValue: 'studentInGame',
        mainTitle: 'Get Students into the Game',
        mainContent: [
            [
                {
                    title: 'First Play Session',
                    content: [
                        {
                            type: 'p',
                            text: 'For the first play session, we recommend <strong>not assigning any content</strong> and giving your students <strong>about 20 minutes</strong>. This includes setting up their avatar and a short tutorial. '
                        },
                        {
                            type: 'p',
                            text: 'Keep in mind if you don&apos;t give them this time, they&apos;re going to want to ignore the first lesson to go see what happens when they jump off cliffs! 😂 😂 😂 '
                        }
                    ]
                },
                {
                    title: 'See Who Has Created a Character',
                    content: [
                        {
                            type: 'p',
                            text: 'You can monitor which students have created their accounts in the “Activity” column of the class roster.'
                        },
                        {
                            type: 'img',
                            text: SeeWhoHasCreatedCharacter
                        }
                    ]
                }
            ]
        ],
        bannerContent:
            'Have your students go to “Play the Game” to open the game. <br/> They will be guided to create their characters and learn the controls.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'See Instructions for the Class',
                url: 'https://docs.google.com/presentation/d/1gXa_e8PQzkLGNypG7fMp8nyQgiT0E4TVV4jtSeemCTc/edit#slide=id.p',
                isExternal: true
            }
        ]
    },
    hasCreatedStudentAssignment: {
        contextValue: 'assignToStudent',
        mainTitle: 'Assign to Students',
        mainContent: [
            [
                {
                    content: [
                        {
                            type: 'img',
                            text: AssignToStudent_1
                        }
                    ]
                },
                {
                    content: [
                        {
                            type: 'custom',
                            text: `
                    <div class="custom-container_assingToStudent">
                    <h4 class='OnboardingDataCard-title'> What An Assignment Means </h4>
                    <ul>
                        <p>When you make an assignment:</p>
                        <li>we will block the content for the assignee until the assigned date</li>
                        <li>once the assignee gets into the game on the assigned date, we will constantly ping the student to go do the assigned content and forbid them from doing other quests until they finish the assigned content</li>
                    </ul>
                    </div>
                    <div class="custom-container_assingToStudent">
                    <h4 class='OnboardingDataCard-title'> Do I have to Assign Content? </h4>
                    <p>
                    Tyto Online has a built-in progression system that goes "micro to macro" and unlocks content for students as they learn pre-requisite knowledge automatically. 
                    </p>
                    <p>
                    Therefore, if you don't assign anything, the students could still play. However, it is likely that you would want to control when and what content they have access to according to your lesson plans.
                    </p>
                    </div>
                    `
                        }
                    ]
                }
            ],
            [
                {
                    content: [
                        {
                            type: 'video',
                            url: 'https://www.youtube.com/embed/KDdirFJE6OA'
                        }
                    ]
                },
                {
                    title: 'Assigning Students',
                    content: [
                        {
                            type: 'p',
                            text: 'Fill out the assignee and date on the assignment popup window to create an assignment. You can assign a whole storyline, a single quest, or a sandbox.'
                        },
                        {
                            type: 'link',
                            text: 'Read More',
                            url: 'https://intercom.help/tytoonline/en/articles/5228401-how-do-i-assign-content-to-my-students'
                        },
                        {
                            type: 'card',
                            title: 'Did You Know?',
                            text: `You can track and manage all the assigned quests to be completed on the “<a href='/calendar'>Calendar</a>” page.`,
                            link: 'https://intercom.help/tytoonline/en/articles/5228387-use-the-calendar-to-keep-track-of-to-be-completed-quests'
                        }
                    ]
                }
            ]
        ],
        bannerContent: 'Go to “Explore &amp; Assign” to assign something to your students.',
        actions: [
            {
                actionType: 'link',
                style: 'blue',
                text: 'Show Me Step by Step',
                url: 'modules?userflow=12327bf8-f58b-467f-8f7e-8bf000e2aa60',
                isExternal: false
            },
            {
                actionType: 'button',
                style: 'white',
                text: 'Skip This Step for Now ',
                isExternal: false
            }
        ]
    },
    hasStudentCompletedQuest: {
        contextValue: 'studentCompleteQuest',
        mainTitle: 'Students Complete First Quests',
        mainText: `Complete the quest “Welcome Citizen” that is automatically given first, or another quest you assigned to your students. You will be able to see how well they mastered the content in <strong>“Track Progress”</strong> afterwards.`,
        bannerContent: 'Get your students into the game and complete a quest.'
    }
}
